export const FeatureKeys = {
  isExampleFlag: 'example-flag',
  bbogDiscoverExperiment: 'bb.og.discover',
  useExperimentApiRecommendations: 'use-experiment-api-recommendations',
  isPrReviewGroupsEnabled: 'pr-review-groups',
  sumCreateWorkspacePreChangeEnabled:
    'ADMINX-1261-workspaces-list-sum-pre-change',
  customMergeChecksActivated: 'custom-merge-checks-activated',
  postOfficeInAppSwitcher: 'post-office-in-bitbucket-switcher',
} as const;

export type FeatureKeyType = (typeof FeatureKeys)[keyof typeof FeatureKeys];

export const pipelinesStatsigKeys = {
  isPipelinesStepFilterEnabled: 'enable_pipelines_step_filter',
  isImprovedLogStreamingRenderingEnabled:
    'bitbucket_pipelines_improve_log_streaming_renders_',
  isMultiStepStageTicketLinkEnabled:
    'bitbucket_pipelines_ticket_link_in_multi_step',
  isPipelinesNavigationDropdownEnabled:
    'bitbucket_pipelines_navigation_dropdown_enabled',
  isPipelinePausedHaltedToStopEnabled:
    'bitbucket_pipelines_paused_halted_pipeline_to_stop',
  buildFixAiAssistantEnabled: 'bitbucket_pipelines_build_fix_ai_assistant',
  deploymentSummaryAiAssistantEnabled:
    'bitbucket_pipelines_deployment_ai_assistant',
  isLogsV3UIRefactorEnabled: 'bitbucket_pipelines_logs_v3_ui_refactor',
  isMaxLogLineLengthEnabled: 'bitbucket_pipelines_max_log_line_length',
  isStepMetricsEnabled: 'bitbucket-pipelines-step-metrics-enabled',
  isPipelineListSidebarEnabled:
    'bitbucket-pipelines-pipeline-list-sidebar-enabled',
  showShadowRepositoryConfiguration:
    'bitbucket-pipelines-show-shadow-repo-configuration',
  isJSDChecksFixEnabled: 'bitbucket_pipelines_jsd_checks_fix',
  isScheduleModalFilterLinkEnabled:
    'bitbucket_pipelines_schedule_filter_link_enabled',
  isPipelinesEnvironmentScreenEnabled: 'bitbucket_pipelines_environment_screen',
  isPipelinesMacOSTartRunnerEnabled: 'pipelines-mac-os-tart-runner',
  pipelinesArtifactPreviewSizeLimit: 'pipelines-artifact-preview-size-limit',
  pipelinesMaximumAllowedStepSizeForCloudRunners:
    'pipelines-max-allowed-step-size-for-cloud-runners',
  isThirdPartySecretsProviderEnabled: 'enable_configure_secrets_provider',
  isBitbucketPipelinesYmlSupportEnabled: 'bitbucket_pipelines_yml_support',
  isExcludePathsChangesetConditionEnabled:
    'exclude_paths_changeset_condition_enabled',
  isSelfHostedRunnerWarningEnabled:
    'bitbucket_pipelines_self_hosted_runner_warning',
  isIncreasedMaxRepoSchedulesEnabled:
    'trigger-service_increased-max-repo-schedules',
  isStepRecommendationsEnabled:
    'bitbucket-pipelines-step-recommendations-enabled',
  isNewArtifactConfigEnabled: 'bitbucket_pipelines_new_artifact_configuration',
  isMergeQueuesEnabled: 'bbc-merge-queue-enabled',
  isPassVariableInSchedulePipelineEnabled:
    'bitbucket_pipelines_variables_in_schedule_pipeline',
  isStepConcurrencyGroupStatusEnabled:
    'bitbucket_pipelines_step_concurrency_status',
};

export const StatsigFeatureKeys = {
  ...pipelinesStatsigKeys,
  copyableBranchName: 'bbc-copyable-branch-name',
  navigationResourceSwitch: 'navigation-resource-switch',
  branchRestrictionsSettingsDisabled:
    'bbc-disable-branch-restrictions-settings',
  mergeStatusStateMessageDisabled: 'bbc-merge-status-state-message-disabled',
  prCreateDeleteBranchDefault: 'bbc-frontbucket-default-delete-branch',
  isRovoDevAgentsCheckEnabled: 'code_reviewer_rovo_dev_agents_enabled_check',
  postOfficeIntegrationInAppSwitcher:
    'post-office-integration-in-bitbucket-switcher',
  disableCompassBitbucketRepositoryCard:
    'disable-compass-bitbucket-repository-card-statsig',
  bbcNoContextFetch: 'bbc_no_context_fetch',
  bbcDefaultDeleteSourceBranchSetting:
    'bbc-default-delete-source-branch-setting',
  nextUnreviewedFile: 'bbc-frontbucket-next-unreviewed-file',
  markAllFiles: 'bbc-frontbucket-mark-all-files',
  supportGitAnnotateOnPRs: 'bbc-frontbucket-support-annotate-on-pr',
  descriptivePrUpdateFlag: 'descriptive_pr_update_flag',
  staleBranchesFilter: 'stale-branch-list-filter',
  newSourceEditor: 'new-source-editor',
  bitbucketLogoRefresh: 'platform-team25-app-icon-tiles',
  bbcAtlaskitEditorCodeSyntaxHighlighting:
    'bbc-atlaskit-editor-code-syntax-highlighting',
  useAddCommentAsDefaultCommentAction:
    'bbc-afmhacks-add-comment-as-default-comment-action',
  isRovoFeatureEnabled: 'bbc-rovo-chat',
  codeReviewerCommentUuidConfig: 'frontbucket-autoreview-comment-uuid',
  webStorageControls: 'bbc-webstorage-controls',
  codeSuggestionsViewMode: 'bbc-code-suggestions-view-mode',
  codeSuggestionsEditMode: 'bbc-code-suggestions-edit-mode',
  autoreviewDogfoodingFlag: 'autoreview-dogfooding-flag',
  repoMigrationFlag: 'fsx-repo-migration-flag',
  frontbucketAccountWorkspaces: 'frontbucket_account_workspaces',
  frontbucketWorkspaceMembers: 'frontbucket_workspace_members',
  frontbucketRepoSourceFileAnnotate: 'frontbucket_repo_source_file_annotate',
  frontbucketRepoSourceFileEdit: 'frontbucket_repo_source_file_edit',
  frontbucketBranchCompare: 'frontbucket_branch_compare',
  frontbucketRepoSourceAddFile: 'frontbucket_repo_source_add_file',
  isChangeFileTreeFilteringEnabled:
    'bbc-frontbucket-enable-change-filetree-filtering',
  tabTitleChangesEnabled: 'bitbucket_tab_title_change',
  myPullRequestsButtonEnabled: 'bitbucket_my_pull_requests_button',
  diffViewNavigationTabsNewThresholdEnabled:
    'bitbucket_diff_view_navigation_tabs',
  bbcBetterImageDiff: 'bbc_better_image_diff',
  prDescriptionImageResizingEnabled:
    'bitbucket_pr_description_image_resizing_enabled',
  isPrTitleQueryParamEnabled: 'pr-title-query-param-enabled',
  enhancedGasV3PREvents: 'enhanced-gasv3-pr-events',
  bbcRefreshedTypography: 'bbc-refreshed-typography',
  disableBranchFetchesByDefault: 'disable-branch-fetches-by-default',
  enableClientSideLinking: 'client-side-links',
  resizableBitbucketRovoChatBar: 'resizable-bitbucket-rovo-chat-bar',
  autoreviewBlockedRepoSlugs: 'autodev-blocked-repos',
  loadShed: 'bbc_load_shed',
  isMultiChunkExpansionInDiffEnabled: 'bbc_multi_chunk_expansion_in_diff',
  prAttachmentsFileService: 'bbc-pr-attachments-file-service',
  defaultPRTabPreference: 'bbc-default-pr-tab-preference',
  syntaxHighlightingGA: 'bbc-syntax-highlighting-ga',
  afmDisableBranchPrefetching: 'bbc-afm-disable-branch-prefetching',
  multilineComments: 'bbc_multi_line_comments',
  persistScrollOnPrTabSwitchEnabled: 'bbc_persist_scroll_on_pr_tab_switch',
  useBbpBuildDataForBranchSelectors:
    'bbc-use-bbp-build-data-for-branch-selectors',
  aiCodeReviewOnboardingFlag: 'bbc-ai-code-review-onboarding',
  codeReviewerStatusCard: 'code_reviewer_status_card',
  prLiveReload: 'bbc-pr-live-reload',
  editorCleanup: 'bbc_editor_cleanup',
  useSharedRendererForUIKit1: 'use_shared_renderer_for_ui_kit_1_-_bbc',
  workspacePullRequestsUserPicker: 'workspace-prs-user-picker-change',
} as const;

export type StatsigFeatureKeyType =
  (typeof StatsigFeatureKeys)[keyof typeof StatsigFeatureKeys];
